import { getMapView } from '@/map/mapStore';
import { resolve, type Source, SourceSchema } from '@/agent/refs';
import type { Tool } from './types';

type Input = {
  source: Source;
  padding?: number;
  zoom_level?: number;
};

export const viewZoomTo: Tool<Input> = {
  name: 'view_zoom_to',
  description:
    'Pan/zoom the map to a Source. Works for places, layer features, feature_sets, sketches, buffers, the user selection, etc.',
  input_schema: {
    type: 'object',
    properties: {
      source: SourceSchema,
      padding: {
        type: 'number',
        description: 'Multiplier applied to the extent before zooming (e.g. 1.2 to widen 20%).',
      },
      zoom_level: { type: 'integer', minimum: 0, maximum: 23 },
    },
    required: ['source'],
    additionalProperties: false,
  },
  execute: async ({ source, padding, zoom_level }) => {
    const view = getMapView();
    if (!view) throw new Error('view.zoom_to: map not initialised');
    const ref = await resolve(source);

    if (typeof zoom_level === 'number' && (ref.geometry?.type === 'point' || ref.extent?.center)) {
      const target =
        ref.geometry?.type === 'point' ? ref.geometry : ref.extent?.center;
      if (target) {
        await view.goTo({ target, zoom: zoom_level });
        return { ok: true, kind: 'point' };
      }
    }

    if (ref.extent) {
      const ext = padding && padding !== 1 ? ref.extent.expand(padding) : ref.extent;
      await view.goTo(ext);
      return { ok: true, kind: 'extent' };
    }

    if (ref.geometry) {
      await view.goTo(ref.geometry);
      return { ok: true, kind: 'geometry' };
    }

    throw new Error('view.zoom_to: nothing to frame');
  },
};
